import { render, staticRenderFns } from "./orderScheduling.vue?vue&type=template&id=4526f420&scoped=true"
import script from "./orderScheduling.vue?vue&type=script&lang=js"
export * from "./orderScheduling.vue?vue&type=script&lang=js"
import style0 from "./orderScheduling.vue?vue&type=style&index=0&id=4526f420&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4526f420",
  null
  
)

export default component.exports